import { useMemo } from "react";

import { Params, useParams } from "react-router-dom";

import {
  useClientRouteContext,
  useCompanyRouteContext
} from "@/components/routes/contexts/RouteContexts";
import { useAppRoutesContext } from "@/routes/context";

const useNamedLink = (
  name: string,
  params: Params = {},
  queryParams: Record<string, any> = {}
) => {
  const routerParams = useParams();
  const { getLink } = useAppRoutesContext();

  // Get context parameters from either client or company context
  const clientContext = useClientRouteContext();
  const companyContext = useCompanyRouteContext();

  // Merge contexts with client context taking precedence for clientId
  const contextParams = useMemo(
    () => ({
      ...companyContext,
      ...clientContext
    }),
    [clientContext, companyContext]
  );

  // Combine parameters from all sources, with explicit params taking precedence
  const combinedParams = useMemo(
    () => ({
      ...contextParams, // First include context params (from Redux)
      ...routerParams, // Then URL params (might override context)
      ...params // Finally explicit params (highest priority)
    }),
    [routerParams, params, contextParams]
  );

  try {
    return getLink(name, combinedParams, queryParams);
  } catch (error) {
    // Fallback to a safe route in case of error
    if (combinedParams.clientId) {
      return `/client/${combinedParams.clientId}`;
    }
    if (combinedParams.companyId) {
      return `/company/${combinedParams.companyId}`;
    }

    return "/";
  }
};

export default useNamedLink;
